import { NavLink } from "react-router-dom";
import { Home, ShoppingBag, Search, Heart, User } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function MobileBottomNav() {
  const { setSearchOpen, wishlist } = useApp();

  const linkCls = ({ isActive }) =>
    `flex flex-col items-center justify-center gap-1 text-[10px] tracking-widest uppercase font-bold ${isActive ? "text-[#E63946]" : "text-white/70"}`;

  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/10 flex justify-around py-2.5">
      <NavLink to="/" end className={linkCls} data-testid="mobnav-home"><Home size={20} /><span>Home</span></NavLink>
      <NavLink to="/shop" className={linkCls} data-testid="mobnav-shop"><ShoppingBag size={20} /><span>Shop</span></NavLink>
      <button onClick={() => setSearchOpen(true)} className="flex flex-col items-center justify-center gap-1 text-[10px] tracking-widest uppercase font-bold text-white/70" data-testid="mobnav-search">
        <Search size={20} /><span>Search</span>
      </button>
      <NavLink to="/wishlist" className={linkCls} data-testid="mobnav-wishlist">
        <div className="relative">
          <Heart size={20} />
          {wishlist.length > 0 && <span className="absolute -top-1 -right-2 bg-[#E63946] text-[9px] w-4 h-4 flex items-center justify-center text-white">{wishlist.length}</span>}
        </div>
        <span>Wishlist</span>
      </NavLink>
      <NavLink to="/account" className={linkCls} data-testid="mobnav-account"><User size={20} /><span>Account</span></NavLink>
    </nav>
  );
}
